if (!customElements.get('sticky-buy-bar')) {
  customElements.define(
    'sticky-buy-bar',
    class StickyBuyBar extends HTMLElement {
      connectedCallback() {
        this.priceEl = this.querySelector('.sticky-buy-bar__price');
        this.submitEl = this.querySelector('.sticky-buy-bar__submit');
        this.productInfo = this.closest('product-info');
        const mainButton = document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
        if (!this.productInfo || !mainButton || !this.submitEl) return;

        // product-info re-renders price/button/picker in place on variant
        // change (and setUnavailable never publishes), so mirror the DOM
        // instead of subscribing to pubsub events.
        this.mutationObserver = new MutationObserver((mutations) => {
          // sync() writes into this bar, which lives inside the observed
          // product-info — ignore our own mutations or we loop forever.
          if (mutations.every((mutation) => this.contains(mutation.target))) return;
          this.requestSync();
        });
        this.mutationObserver.observe(this.productInfo, {
          subtree: true,
          childList: true,
          attributes: true,
          characterData: true,
        });
        this.sync();
        this.watchFooter();
      }

      disconnectedCallback() {
        this.mutationObserver?.disconnect();
        this.footerObserver?.disconnect();
      }

      // The bar slides away as the footer arrives, so it never sits over it.
      // rootMargin pulls the viewport's bottom edge up by the bar's own height,
      // so the trigger is the footer's top edge meeting the bar's top edge, not
      // the bottom of the screen. The bar height is stable on a phone, so it is
      // measured once.
      watchFooter() {
        const footer = document.querySelector('.footer') || document.getElementById('shopify-section-footer');
        if (!footer) return;
        this.footerObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.classList.toggle('is-hidden', entry.isIntersecting);
              this.toggleAttribute('inert', entry.isIntersecting);
            });
          },
          { rootMargin: `0px 0px -${this.offsetHeight}px 0px`, threshold: 0 }
        );
        this.footerObserver.observe(footer);
      }

      requestSync() {
        if (this.syncScheduled) return;
        this.syncScheduled = true;
        requestAnimationFrame(() => {
          this.syncScheduled = false;
          this.sync();
        });
      }

      sync() {
        const mainButton = document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
        if (!mainButton) return;

        const label = mainButton.querySelector('span')?.textContent.trim();
        const labelEl = this.submitEl.querySelector('.sticky-buy-bar__label');
        if (label && labelEl && labelEl.textContent !== label) labelEl.textContent = label;
        this.submitEl.toggleAttribute('disabled', mainButton.hasAttribute('disabled'));
        // aria-disabled marks the in-flight add; the form's own submit guard
        // prevents double submission, so keep the button focusable.
        const ariaDisabled = mainButton.getAttribute('aria-disabled') === 'true';
        if (this.submitEl.hasAttribute('aria-disabled') !== ariaDisabled) {
          if (ariaDisabled) {
            this.submitEl.setAttribute('aria-disabled', 'true');
          } else {
            this.submitEl.removeAttribute('aria-disabled');
          }
        }
        const haspopup = mainButton.getAttribute('aria-haspopup');
        if (haspopup && this.submitEl.getAttribute('aria-haspopup') !== haspopup) {
          this.submitEl.setAttribute('aria-haspopup', haspopup);
        }

        const priceContainer = document.getElementById(`price-${this.dataset.sectionId}`);
        const priceItem = priceContainer?.querySelector(
          '.price__sale .price-item--sale, .price__regular .price-item--regular'
        );
        const priceHidden = !priceItem || priceContainer.classList.contains('hidden');
        this.priceEl.classList.toggle('hidden', priceHidden);
        if (!priceHidden) {
          const priceText = priceItem.textContent.trim();
          if (this.priceEl.textContent !== priceText) this.priceEl.textContent = priceText;
        }
      }
    }
  );
}
